import Config from 'common-src/config';

export const initialState = {
  practiceId: '',
  departmentId: null,
};

export const AthenaDepartmentIdOptions = [
  { label: 'Neurology Danvers', value: 1 },
  { label: 'GUIDE', value: 2 },
  { label: 'Neurology Orange County', value: Config.ATHENA_NEUROLOGY_ORANGE_COUNTY_DEPARTMENT_ID },
];
